import { ele } from "cables-shared-client";

export default class Buttons
{
    startSavingAnimButton(buttonEle, title = "Working...")
    {
        if (!buttonEle) return;
        buttonEle.classList.remove("buttonSavingError");
        if (!buttonEle.classList.contains("buttonSavingAnim"))
        {
            this.buttonSavingEle = buttonEle;
            this.buttonSavingText = buttonEle.innerHTML;
            buttonEle.innerText = title;

            const e = document.createElement("span");
            e.classList.add("icon-loader");
            e.classList.add("icon");
            e.classList.add("icon-0_75x");
            e.style.backgroundColor = "#000";

            e.style["margin-left"] = "10px";

            buttonEle.classList.add("buttonSavingAnim");

            buttonEle.appendChild(e);
            this.buttonSavingStart = performance.now();
        }
    }

    stopSavingAnimButton(buttonEle = null, showDoneText = true, isError = false)
    {
        if (performance.now() - this.buttonSavingStart < 200)
        {
            setTimeout(() =>
            {
                this.stopSavingAnimButton(buttonEle, showDoneText, isError);
            }, 50);
            return;
        }

        let buttonsloadingIcons = [];
        let buttonsloading = [];
        if (buttonEle && buttonEle.querySelectorAll)
        {
            const buttonsIcons = buttonEle.querySelectorAll(".icon-loader");
            if (buttonsIcons.length > 0) buttonsloadingIcons = buttonsIcons;
            buttonsloading.push(buttonEle);
        }
        else
        {
            buttonsloadingIcons = ele.byQueryAll(".buttonSavingAnim .icon-loader");
            buttonsloading = ele.byQueryAll(".buttonSavingAnim");
        }

        const button = buttonEle || this.buttonSavingEle;
        let timeout = 400;
        if (button)
        {
            if (showDoneText)
            {
                if (isError)
                {
                    if (buttonEle) buttonEle.classList.add("buttonSavingError");
                    button.innerText = "Error!";
                    timeout = 2000;
                }
                else
                {
                    button.innerText = "Done!";
                }
            }

            setTimeout(() =>
            {
                button.classList.remove("buttonSavingError");
                button.innerHTML = this.buttonSavingText;
            }, timeout);
        }

        if (buttonsloading)
            for (let i = 0; i < buttonsloading.length; i++)
                buttonsloading[i].classList.remove("buttonSavingAnim");

        if (buttonsloadingIcons)
            for (let i = 0; i < buttonsloadingIcons.length; i++)
                buttonsloadingIcons[i].remove();
    }
}
